import { columns as baseColumns } from './EncounterColumn';
import { ehrSubmitDocument } from 'src/modules/EHR/store/slices/ehr';
import { Tooltip } from 'antd';

/**
 * Wrapper around the base columns function that adds embedded mode behavior.
 * In embedded mode, only pinned encounters are selectable.
 */
export const embeddedColumns = ({
  encounterList,
  humanScribeStatus,
  setHoveredRowIndex,
  editingRow,
  setEditingRow,
  handleDescriptionChange,
  handleCancelEdit,
  storedParams,
  handleSaveDescription,
  hoveredRowIndex,
  handleQrCodeOpen,
  searchFilters,
  schedulepage,
  autoChangeStatusToInProgress,
  setCurrentEncounter,
  setRecord,
  setIsStreaming,
  setIsRecording,
  isHumanScribeEntitled,
  encounterPhase,
  editedSummary,
  selectedRecord,
  setSelectedRecord,
  setSearchFilters,
  currentPractitioner,
  pinnedEncounterIds = [],
  dispatch,
  needsZoomReauth = false,
  navigate,
  isEmbeddedWithEncounter = false,
  pinnedEncounterList = [],
  setSelectedEncounter,
}) => {
  // Get the base columns
  const cols = baseColumns({
    encounterList,
    humanScribeStatus,
    setHoveredRowIndex,
    editingRow,
    setEditingRow,
    handleDescriptionChange,
    handleCancelEdit,
    storedParams,
    handleSaveDescription,
    hoveredRowIndex,
    handleQrCodeOpen,
    searchFilters,
    schedulepage,
    autoChangeStatusToInProgress,
    setCurrentEncounter,
    setRecord,
    setIsStreaming,
    setIsRecording,
    isHumanScribeEntitled,
    encounterPhase,
    editedSummary,
    selectedRecord,
    setSelectedRecord,
    setSearchFilters,
    currentPractitioner,
    pinnedEncounterIds,
    dispatch,
    needsZoomReauth,
    navigate,
    setSelectedEncounter,
  });

  // If not in embedded mode, return base columns as-is
  if (!isEmbeddedWithEncounter) {
    return cols;
  }

  // Override the onCell handler and render for embedded mode
  return cols.map((col) => {
    if (col.key === 'description') {
      const baseRender = col.render;
      return {
        ...col,
        render: (text, record, rowIndex) => {
          const isPinned = pinnedEncounterList?.some(
            (enc) => enc.encounter_id === record.encounter_id
          );
          const baseContent = baseRender(text, record, rowIndex);

          if (!isPinned) {
            return (
              <Tooltip
                title="Launch from patient chart in OP to enable this encounter"
                placement="top"
              >
                {baseContent}
              </Tooltip>
            );
          }
          return baseContent;
        },
        onCell: (record) => {
          const isPinned = pinnedEncounterList?.some(
            (enc) => enc.encounter_id === record.encounter_id
          );

          return {
            onClick: () => {
              if (!isPinned) {
                return;
              }
              setRecord(record);
              setIsStreaming(false);
              dispatch(ehrSubmitDocument(null));
              setIsRecording(false);
              setCurrentEncounter(record);
              autoChangeStatusToInProgress(record);
              setSelectedEncounter?.(record);
            },
            style: isPinned ? {} : { cursor: 'not-allowed', opacity: 0.6 },
          };
        },
      };
    }
    return col;
  });
};
